import { useQuery } from '@apollo/client';

import { UserProfile } from '../../types';
import { UserProfileQueryDocument } from './userProfileQuery.gql';

export const useUserProfile = () => {
  const { data, error, loading } = useQuery(UserProfileQueryDocument);
  const user = data?.viewer?.profile as UserProfile;
  return { error, loading, user };
};
